import axios from 'axios';

export const PROMOTIONS_PUBLISHED = 'PROMOTIONS_PUBLISHED';

const publishPromotions = (teamId, productId, promotionMethodIds, emailChanges) => (
  (dispatch) => {
    return axios.post(
      `/api/teams/${teamId}/products/${productId}/promote`,
      {
        promotion_method_ids: promotionMethodIds,
        email_changes: emailChanges,
      },
    ).then((response) => {
      dispatch({
        type: PROMOTIONS_PUBLISHED,
        teamId,
        productId,
      });

      return response;
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        window.location = '/login';
      }
    });
  }
);

export default publishPromotions;
